const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "351912010025";
export const INSTAGRAM_URL = "https://www.instagram.com/sophitrisportugal";
export const BOOK_URL = "https://publishpt.bookmundo.com/books/22069315";

// WhatsApp message builder
export function whatsappLink(service) {
  const messages = {
    default: "Olá, encontrei a Sophitris através do website e gostaria de saber mais sobre os vossos serviços.",
    oraculo: "Olá, encontrei a Sophitris através do website e gostaria de marcar uma sessão de Oráculo Oculto. Podem informar-me sobre a disponibilidade?",
    mesa: "Olá, encontrei a Sophitris através do website e gostaria de marcar uma sessão de Mesa Radiónica das Consciências. Podem informar-me sobre a disponibilidade?",
    kundalini: "Olá, encontrei a Sophitris através do website e gostaria de marcar uma Kundalini Experience. Podem informar-me sobre a disponibilidade?",
    completa: "Olá, encontrei a Sophitris através do website e gostaria de marcar a Experiência Ocultista Completa. Podem informar-me sobre a disponibilidade?",
    magnetismo: "Olá, encontrei a Sophitris através do website e gostaria de saber mais sobre o Ritual de Magnetismo Pessoal. Podem informar-me sobre a disponibilidade?",
    prosperidade: "Olá, encontrei a Sophitris através do website e gostaria de saber mais sobre o programa de Prosperidade e Consciência Financeira. Podem informar-me sobre a disponibilidade?",
    contacto: "Olá, encontrei a Sophitris através do website e gostaria de entrar em contacto.",
  };
  const msg = messages[service] || messages.default;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

// Logos (existing)
export const LOGO_SYMBOL = "https://static.prod-images.emergentagent.com/jobs/903439b1-dc43-461f-a3d9-19c1b64a3655/images/c5b7079421192598f47c5431b8b3cd2b61750cbe3068e79ffb9ff88cfe91473a.png";
export const LOGO_NEW = "https://customer-assets-jai6qajn.emergentagent.net/job_high-ticket-landing-2/artifacts/8zo9ysvc_file_00000000bac071f49a98cca34c203692.png";
export const BOOK_COVER = "https://customer-assets.emergentagent.com/job_high-ticket-landing-2/artifacts/fpyd703l_1%20%281%29.png";

// Ambient Photos (existing)
export const AMBIENT_1 = "https://customer-assets-jai6qajn.emergentagent.net/job_high-ticket-landing-2/artifacts/zq7v9dxy_file_0000000050d471f489ec98d411958cef.png";
export const AMBIENT_2 = "https://customer-assets-jai6qajn.emergentagent.net/job_high-ticket-landing-2/artifacts/8d7o884m_file_00000000dff471f494a4ec6dc6e7ba9c.png";

// Kundalini Hero
export const KUNDALINI_IMAGE = "https://static.prod-images.emergentagent.com/jobs/903439b1-dc43-461f-a3d9-19c1b64a3655/images/3168dcec5ba10e13ac6a4facc1864dacddfcb224243145f8bbca2c94c910e026.png";

// Stock images
export const IMG_HERO = "https://images.unsplash.com/photo-1693648793394-0b76b7eb042e?w=1920&q=80&auto=format";
export const IMG_TAROT = "https://images.unsplash.com/photo-1694144167581-8bc49479f6b7?w=800&q=80&auto=format";
export const IMG_TAROT_DARK = "https://images.unsplash.com/photo-1607773709367-06b7a91f7e4a?w=800&q=80&auto=format";
export const IMG_PENDULUM = "https://images.unsplash.com/photo-1641295432323-e48be738df17?w=800&q=80&auto=format";
export const IMG_MEDITATION = "https://images.unsplash.com/photo-1577344718665-3e7c0c1ecf6b?w=800&q=80&auto=format";
export const IMG_RITUAL = "https://images.unsplash.com/photo-1635645476269-898afcfa6694?w=800&q=80&auto=format";
export const IMG_CANDLES = "https://images.unsplash.com/photo-1689184656466-9be6563cb925?w=800&q=80&auto=format";
export const IMG_GOLD_ROSE = "https://images.unsplash.com/photo-1786835570840-2a05c234604d?w=800&q=80&auto=format";
export const IMG_TEMPLE = "https://images.unsplash.com/photo-1774736358038-c3da6cbf8d0e?w=1920&q=80&auto=format";
export const IMG_CEREMONY = "https://images.unsplash.com/photo-1666625785123-49643dba7ee2?w=800&q=80&auto=format";

// Services data
export const SERVICES = [
  {
    id: "oraculo-oculto",
    slug: "/oraculo-oculto",
    image: "https://images.unsplash.com/photo-1694144167581-8bc49479f6b7?w=800&q=80&auto=format",
    whatsapp: "oraculo",
    priceFrom: 40,
  },
  {
    id: "mesa-radionica",
    slug: "/mesa-radionica",
    image: "https://images.unsplash.com/photo-1625992418579-418eb5e843af?w=800&q=80&auto=format",
    whatsapp: "mesa",
    price: 90,
  },
  {
    id: "kundalini",
    slug: "/kundalini",
    image: "https://images.unsplash.com/photo-1577344718665-3e7c0c1ecf6b?w=800&q=80&auto=format",
    whatsapp: "kundalini",
    price: 80,
  },
  {
    id: "experiencia-ocultista",
    slug: "/rituais",
    image: "https://images.unsplash.com/photo-1666625785123-49643dba7ee2?w=800&q=80&auto=format",
    whatsapp: "completa",
    price: 150,
  },
  {
    id: "magnetismo-pessoal",
    slug: "/rituais",
    image: "https://images.unsplash.com/photo-1635645476269-898afcfa6694?w=800&q=80&auto=format",
    whatsapp: "magnetismo",
    price: 300,
  },
  {
    id: "prosperidade",
    slug: "/rituais",
    image: "https://images.unsplash.com/photo-1786835570840-2a05c234604d?w=800&q=80&auto=format",
    whatsapp: "prosperidade",
    price: 400,
  },
];
